import SidebarMainNavbar from "./SidebarMainNavbar";
import SidebarNavItems from "./SidebarNavItems";

const SideNavBar = ({ classes, sidebarNavItems, userInfo }) => {
  return (
    <>
      <div tag="aside" className={classes}>
        <SidebarMainNavbar />
        <SidebarNavItems
          sidebarNavItems={sidebarNavItems}
          userInfo={userInfo}
        />
      </div>
    </>
  );
};

export default SideNavBar;
